import React, { useEffect } from "react";
import { motion } from "framer-motion";
import github from "../../img/github.svg";
import linkedin from "../../img/linkedin.svg";
import ppt from "../../img/ppt.jpg";
import "./intro.css";

const Intro = () => {
  const transition = { duration: 1.6, type: "spring" };

  useEffect(() => {
    const images = document.querySelectorAll(".portfolio-img");
    images.forEach((img) => {
      img.addEventListener("load", () => {
        img.classList.add("loaded");
      });
    });
  }, []);

  return (
    <section className="intro">
      <motion.div
        className="i-left"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={transition}
      >
        <div className="i-name">
          <h1 className="i-title">Mohamed Ali</h1>
          <span className="i-eyebrow">
            Full-Stack Web Developer
          </span>
          <span className="introDetails">
            I design and build secure, scalable software across the full stack,
            with a focus on applying AI to solve real engineering problems —
            from production-ready web applications to intelligent, data-driven
            systems. Open to opportunities in software engineering, AI/ML
            engineering, and full-stack web development.
          </span>
        </div>

        <div className="i-icons">
          <a
            href="https://github.com/devMoAli"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            <img src={github} alt="GitHub" />
          </a>
          <a
            href="https://www.linkedin.com/in/dev-mohamed-ali/"
            aria-label="LinkedIn"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedin} alt="LinkedIn" />
          </a>
        </div>
      </motion.div>

      <motion.div
        className="i-right"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={transition}
      >
        <div className="hero-visual">
          <div className="frosted-glass-frame">
            <img
              src={ppt}
              alt="Portrait of Mohamed Ali"
              className="profilePic-idea7 portfolio-img"
              loading="lazy"
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Intro;
